function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-undef */

/**
 * @module org/locationtech/jts/io/OL3Parser
 */

import Coordinate from '../geom/Coordinate';
import GeometryFactory from '../geom/GeometryFactory';
function p2c(p) {
  return [p.x, p.y];
}
var OL3Parser = /*#__PURE__*/function () {
  /**
   * OpenLayers Geometry parser and writer
   * @param {GeometryFactory} geometryFactory
   * @param {ol} olReference
   */
  function OL3Parser(geometryFactory, olReference) {
    _classCallCheck(this, OL3Parser);
    this.geometryFactory = geometryFactory || new GeometryFactory();
    this.ol = olReference || typeof ol !== 'undefined' && ol;
  }

  /**
   * Inject OpenLayers geom classes
   */
  return _createClass(OL3Parser, [{
    key: "inject",
    value: function inject(Point, LineString, LinearRing, Polygon, MultiPoint, MultiLineString, MultiPolygon, GeometryCollection) {
      this.ol = {
        geom: {
          Point: Point,
          LineString: LineString,
          LinearRing: LinearRing,
          Polygon: Polygon,
          MultiPoint: MultiPoint,
          MultiLineString: MultiLineString,
          MultiPolygon: MultiPolygon,
          GeometryCollection: GeometryCollection
        }
      };
    }

    /**
     * @param geometry {ol.geom.Geometry}
     * @return {Geometry}
     * @memberof module:org/locationtech/jts/io/OL3Parser#
     */
  }, {
    key: "read",
    value: function read(geometry) {
      var ol = this.ol;
      if (geometry instanceof ol.geom.Point) {
        return this.convertFromPoint(geometry);
      } else if (geometry instanceof ol.geom.LineString) {
        return this.convertFromLineString(geometry);
      } else if (geometry instanceof ol.geom.LinearRing) {
        return this.convertFromLinearRing(geometry);
      } else if (geometry instanceof ol.geom.Polygon) {
        return this.convertFromPolygon(geometry);
      } else if (geometry instanceof ol.geom.MultiPoint) {
        return this.convertFromMultiPoint(geometry);
      } else if (geometry instanceof ol.geom.MultiLineString) {
        return this.convertFromMultiLineString(geometry);
      } else if (geometry instanceof ol.geom.MultiPolygon) {
        return this.convertFromMultiPolygon(geometry);
      } else if (geometry instanceof ol.geom.GeometryCollection) {
        return this.convertFromCollection(geometry);
      }
    }
  }, {
    key: "convertFromPoint",
    value: function convertFromPoint(point) {
      var coordinates = point.getCoordinates();
      return this.geometryFactory.createPoint(new Coordinate(coordinates[0], coordinates[1]));
    }
  }, {
    key: "convertFromLineString",
    value: function convertFromLineString(lineString) {
      return this.geometryFactory.createLineString(lineString.getCoordinates().map(function (coordinates) {
        return new Coordinate(coordinates[0], coordinates[1]);
      }));
    }
  }, {
    key: "convertFromLinearRing",
    value: function convertFromLinearRing(linearRing) {
      return this.geometryFactory.createLinearRing(linearRing.getCoordinates().map(function (coordinates) {
        return new Coordinate(coordinates[0], coordinates[1]);
      }));
    }
  }, {
    key: "convertFromPolygon",
    value: function convertFromPolygon(polygon) {
      var linearRings = polygon.getLinearRings();
      var shell = null;
      var holes = [];
      for (var i = 0; i < linearRings.length; i++) {
        var linearRing = this.convertFromLinearRing(linearRings[i]);
        if (i === 0) {
          shell = linearRing;
        } else {
          holes.push(linearRing);
        }
      }
      return this.geometryFactory.createPolygon(shell, holes);
    }
  }, {
    key: "convertFromMultiPoint",
    value: function convertFromMultiPoint(multiPoint) {
      var points = multiPoint.getPoints().map(function (point) {
        return this.convertFromPoint(point);
      }, this);
      return this.geometryFactory.createMultiPoint(points);
    }
  }, {
    key: "convertFromMultiLineString",
    value: function convertFromMultiLineString(multiLineString) {
      var lineStrings = multiLineString.getLineStrings().map(function (lineString) {
        return this.convertFromLineString(lineString);
      }, this);
      return this.geometryFactory.createMultiLineString(lineStrings);
    }
  }, {
    key: "convertFromMultiPolygon",
    value: function convertFromMultiPolygon(multiPolygon) {
      var polygons = multiPolygon.getPolygons().map(function (polygon) {
        return this.convertFromPolygon(polygon);
      }, this);
      return this.geometryFactory.createMultiPolygon(polygons);
    }
  }, {
    key: "convertFromCollection",
    value: function convertFromCollection(collection) {
      var geometries = collection.getGeometries().map(function (geometry) {
        return this.read(geometry);
      }, this);
      return this.geometryFactory.createGeometryCollection(geometries);
    }

    /**
     * @param geometry
     *          {Geometry}
     * @return {ol.geom.Geometry}
     * @memberof module:org/locationtech/jts/io/OL3Parser#
     */
  }, {
    key: "write",
    value: function write(geometry) {
      if (geometry.getGeometryType() === 'Point') {
        return this.convertToPoint(geometry.getCoordinate());
      } else if (geometry.getGeometryType() === 'LineString') {
        return this.convertToLineString(geometry);
      } else if (geometry.getGeometryType() === 'LinearRing') {
        return this.convertToLinearRing(geometry);
      } else if (geometry.getGeometryType() === 'Polygon') {
        return this.convertToPolygon(geometry);
      } else if (geometry.getGeometryType() === 'MultiPoint') {
        return this.convertToMultiPoint(geometry);
      } else if (geometry.getGeometryType() === 'MultiLineString') {
        return this.convertToMultiLineString(geometry);
      } else if (geometry.getGeometryType() === 'MultiPolygon') {
        return this.convertToMultiPolygon(geometry);
      } else if (geometry.getGeometryType() === 'GeometryCollection') {
        return this.convertToCollection(geometry);
      }
    }
  }, {
    key: "convertToPoint",
    value: function convertToPoint(coordinate) {
      return new this.ol.geom.Point([coordinate.x, coordinate.y]);
    }
  }, {
    key: "convertToLineString",
    value: function convertToLineString(lineString) {
      var points = lineString._points._coordinates.map(p2c);
      return new this.ol.geom.LineString(points);
    }
  }, {
    key: "convertToLinearRing",
    value: function convertToLinearRing(linearRing) {
      var points = linearRing._points._coordinates.map(p2c);
      return new this.ol.geom.LinearRing(points);
    }
  }, {
    key: "convertToPolygon",
    value: function convertToPolygon(polygon) {
      var rings = [polygon._shell._points._coordinates.map(p2c)];
      for (var i = 0; i < polygon._holes.length; i++) {
        rings.push(polygon._holes[i]._points._coordinates.map(p2c));
      }
      return new this.ol.geom.Polygon(rings);
    }
  }, {
    key: "convertToMultiPoint",
    value: function convertToMultiPoint(multiPoint) {
      return new this.ol.geom.MultiPoint(multiPoint.getCoordinates().map(p2c));
    }
  }, {
    key: "convertToMultiLineString",
    value: function convertToMultiLineString(multiLineString) {
      var lineStrings = [];
      for (var i = 0; i < multiLineString._geometries.length; i++) {
        lineStrings.push(this.convertToLineString(multiLineString._geometries[i]).getCoordinates());
      }
      return new this.ol.geom.MultiLineString(lineStrings);
    }
  }, {
    key: "convertToMultiPolygon",
    value: function convertToMultiPolygon(multiPolygon) {
      var polygons = [];
      for (var i = 0; i < multiPolygon._geometries.length; i++) {
        polygons.push(this.convertToPolygon(multiPolygon._geometries[i]).getCoordinates());
      }
      return new this.ol.geom.MultiPolygon(polygons);
    }
  }, {
    key: "convertToCollection",
    value: function convertToCollection(geometryCollection) {
      var geometries = [];
      for (var i = 0; i < geometryCollection._geometries.length; i++) {
        var geometry = geometryCollection._geometries[i];
        geometries.push(this.write(geometry));
      }
      return new this.ol.geom.GeometryCollection(geometries);
    }
  }]);
}();
export { OL3Parser as default };